const EMPTY_AWS_EXPORTS = { oauth: {} };

const shouldUseEmptyAwsExports = (error) =>
  process.env.NODE_ENV === 'test' &&
  error?.code === 'MODULE_NOT_FOUND' &&
  typeof error.message === 'string' &&
  error.message.includes("'./aws-exports'");

let awsExports;

try {
  // `src/aws-exports.js` is generated before start/build, but CI tests run from a clean checkout.
  // Fall back to an empty config during tests so unit tests stay hermetic.
  const generatedAwsExports = require('./aws-exports');
  awsExports = generatedAwsExports.default || generatedAwsExports;
} catch (error) {
  if (!shouldUseEmptyAwsExports(error)) {
    throw error;
  }

  awsExports = EMPTY_AWS_EXPORTS;
}

export default awsExports;
